import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {Provider} from "react-redux";
import {initSentry} from "config/sentry";
// Boots the Redux store and its saveState subscription.
import {store} from "webform/store/store";
import App from "./App";
// index.css pulls in Tailwind v4 + @bolteu/clay-tailwind, which provide clay's
// component styles and the bolt-font-*/color utility classes.
import "./index.css";

initSentry();

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </StrictMode>,
);
